import React from 'react';
const AssociatedSVG = ({ color = '#0957D0', className, onClick }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='12'
      viewBox='0 0 20 12'
      fill='none'
      className={className}
      onClick={onClick}
    >
      <path
        d='M11.6001 0.599609H13.6001C16.3615 0.599609 18.6001 2.83819 18.6001 5.59961C18.6001 8.36101 16.3615 10.5996 13.6001 10.5996H11.6001M7.6001 0.599609H5.6001C2.83868 0.599609 0.600098 2.83819 0.600098 5.59961C0.600098 8.36101 2.83868 10.5996 5.6001 10.5996H7.6001M5.6001 5.59961H13.6001'
        stroke={color}
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default AssociatedSVG;
